<template>
  <div class="bg-blue" :class="screenSize">
    <!-- 상단 고정 캠페인 배너 -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :staticMode="false"
    ></TopAppBar>
    <div class="pdb-20" v-if="purchaseDetails">
      <div id="tab1" class="t-color-content1 pdt-16 pdl-16 pdr-16 bg-blue">
        <div class="t-color-dark t-headline9 l-spacing6 font-b pdb-8 mgt-60">
          {{ $t("581") }}
        </div>
        <div class="t-color-dark t-body3 l-spacing42 font-r mgb-16 opacity8">
          {{ $t("S20037") }}
        </div>
        <div class="bg-white">
          <div class="headerRoll position-relative">
            <div class="bg-white position-relative h-29 z-99">
              <div class="header-shadow"></div>
            </div>
          </div>
        </div>

        <div class="pdl-16 pdr-16 receipt-wrapper position-relative bg-white">
          <div class="t-subtitle2 t-color-title l-spacing48 font-b">
            {{ $t("583") }}
          </div>
          <div class="t-body1 t-color-title l-spacing48 pdt-16 pdb-16 font-r">
            {{
              purchaseDetails && purchaseDetails.product
                ? purchaseDetails.product.name
                : ""
            }}
          </div>
          <div class="divider"></div>
          <div class="t-body3 t-color-content1 pdt-18 pdb-5 font-r l-spacing42">
            {{ $t("585") }}
          </div>
          <div class="t-body1 t-color-title pdb-10 l-spacing42 f-weight500">
            {{
              $moment(purchaseDetails.buyRequestDatetime).format("YYYY.MM.DD")
            }}
          </div>

          <div class="divider dashed mgb-8 mgt-8"></div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20010") }}
          </div>
          <div class="d-flex align-items-center">
            <div class="pdr-3 t-body3 t-color-title">
              <div class="mgr-2">
                <img
                  src="images/prize_request/p-image.svg"
                  class="w-24 h-24"
                  alt=""
                />
              </div>
            </div>
            <div class="t-body1 t-color-red1 l-spacing42 pdl-4">
              {{ pay_through_points }}
            </div>
          </div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20011") }}
          </div>
          <div class="d-flex align-items-center">
            <div class="pdr-3 t-body3 t-color-title">
              <div class="mgr-2">
                <img
                  src="images/prize_request/p-image.svg"
                  class="w-24 h-24"
                  alt=""
                />
              </div>
            </div>
            <div class="t-body1 t-color-title l-spacing42 pdl-4">
              {{ remaining_points }}
            </div>
          </div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("1990") }}
          </div>
          <div class="t-body1 t-color-title pdb-27 l-spacing42 font-r">
            {{
              $t("1991", {
                str:
                  purchaseDetails && purchaseDetails.quantity
                    ? purchaseDetails.quantity
                    : "",
              })
            }}
          </div>
        </div>
      </div>
      <div class="receipt-wrapper-bottom h-20 mgl-14 mgr-16"></div>

      <div class="pdl-16 pdr-16 mgb-34 mgt-50">
        <router-link
          class="d-block bg-white t-color-red1 t-center pdt-11 pdb-10 pdl-16 pdr-16 b-radius4 b-shadow2 t-body2"
          to="/prize-request"
        >
          {{ $t("593") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCRipple } from "@material/ripple";
import NoData from "../common/NoData.vue";
import prizeRequestApi from "@/api/prizeRequestApi.js";

export default {
  components: {
    NoData,
    TopAppBar,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      purchaseDetails: null,
      infiniteId: +new Date(),
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      prize_id: null,
      pay_through_points: 0,
      remaining_points: 0,
      user_points: localStorage.getItem("user_point"),
      screenSize: "",
      innerHeight: "",
    };
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  computed: {},

  watch: {},

  mixins: [topAppBarMixin],

  mounted() {
    if (window.innerHeight > 640) {
      this.screenSize = "h-full";
    } else {
      this.screenSize = "";
    }

    this.setTopAppBarTitleOnly(this.$t("580"));
    this.prize_id = this.$route.params.prizeid;

    this.fetchData();
  },

  methods: {
    fetchData($state) {
      prizeRequestApi
        .prizePurchaseDetailHistory(this.prize_id)
        .then((response) => {
          console.log("purchase details", response.data.data);
          this.purchaseDetails = response.data.data;
          this.pay_through_points =
            this.purchaseDetails.product.price * this.purchaseDetails.quantity;
          this.remaining_points = this.user_points - this.pay_through_points;
        })
        .catch((err) => {});
    },
    myEventHandler(e) {
      console.log(e.target.outerHeight);
      console.log("window.innerHeight;", window.innerHeight);
      if (e.target.outerHeight > 640 || this.innerHeight > 640) {
        this.screenSize = "h-full";
      } else {
        this.screenSize = "";
      }
    },

    // 파라미터 설정(set parameter)
  },
};
</script>

<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z4 {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  /* background-color: #ffffff; */
}

.no-border {
  border: none;
  outline: none;
  box-shadow: none;
}
.t-color-dark {
  color: #313d4b;
}
.opacity8 {
  opacity: 0.8;
}
.header-shadow {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
}
.header-shadow:before {
  width: 100%;
  height: 29px;
  opacity: 0.7;
  background-image: linear-gradient(
    to bottom,
    #acb4be,
    rgba(219, 219, 219, 0) 67%
  );
  position: absolute;
  content: "";
  left: 50%;
  transform: translateX(-50%);
  top: 0;
}
.headerRoll:after,
.headerRoll:before {
  width: 20px;
  height: 14px;
  border-radius: 7px;
  background-color: #80aed4;
  position: absolute;
  content: "";
  top: 0;
  transform: translateX(-50%);
}
.headerRoll:after {
  right: -20px;
}
.headerRoll:before {
  left: 0;
}
.z-99 {
  z-index: 99;
}
.l-spacing5 {
  letter-spacing: 0.5px;
}
.receipt-wrapper-bottom {
  background: url("/images/prize_request/border-bottom1.svg");
  margin-top: -11px;
}
.f-weight500 {
  font-weight: 500 !important;
}
.bg-blue1 {
  background: #2d6dcc !important;
}
html {
  background: #ebf0f6 !important;
}
</style>
